import React, { useEffect, createElement } from 'react';
import { Check, Lock, ShieldCheck, Leaf } from 'lucide-react';
const HOP_LINK = 'https://dc37c4ijke0gr8mbt9ld2rm7ak.hop.clickbank.net';
const GREEN = '#2d6a4f';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
const handleCtaClick = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout');
  }
};
export function App() {
  useEffect(() => {
    // Inject Facebook Pixel Base Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '666521186552257');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=666521186552257&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (script.parentNode) document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  const bullets = ['Supports healthy gums and strong teeth', 'Naturally helps clear sinus congestion', 'Helps balance digestion and reduces bloating', 'Works in less than 60 seconds a day', 'No prescription needed'];
  return <div className="min-h-screen w-full bg-white text-[#1a1a1a]" data-id="element-0">
      {/* TOP BANNER */}
      <div className="w-full bg-[#f5f5f5]" data-id="element-1">
        <div className="mx-auto max-w-[750px] px-5 sm:px-6 py-2 text-center" data-id="element-2">
          <p className="text-[11px] sm:text-xs text-gray-600 tracking-wide" data-id="element-3">
            Health Discovery Report{' '}
            <span className="text-gray-400 mx-1" data-id="element-4">|</span> Updated 2024
          </p>
        </div>
      </div>

      <article className="mx-auto max-w-[750px] px-5 sm:px-6 py-10 sm:py-14" data-id="element-5">
        {/* HEADLINE */}
        <h1 className="font-article text-center text-[30px] sm:text-[42px] lg:text-[46px] font-bold leading-[1.2] text-[#1a1a1a] mb-6 sm:mb-8" data-id="element-6">
          The Surprising Link Between Your Teeth, Your Sinuses, and Your
          Digestion…
        </h1>

        {/* SUB-HEADLINE */}
        <p className="text-center text-[17px] sm:text-[19px] italic leading-relaxed text-[#555555] max-w-[640px] mx-auto mb-10" data-id="element-7">
          Why thousands of people over 35 are ditching traditional dental
          routines for this 'Total Body' oral secret.
        </p>

        {/* DIVIDER */}
        <hr className="border-0 border-t border-[#e0e0e0] mb-10" data-id="element-8" />

        {/* FEATURED IMAGE */}
        <figure className="mb-10" data-id="element-9">
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=1200&q=80" alt="A smiling woman in her 50s standing in her morning kitchen" className="block mx-auto w-full max-w-[560px] h-auto rounded-lg object-cover shadow-sm" data-id="element-10" />
          <figcaption className="text-center text-[13px] italic text-gray-500 mt-3" data-id="element-11">
            Thousands of people over 35 are discovering this hidden connection.
          </figcaption>
        </figure>

        {/* BODY COPY */}
        <div className="mx-auto max-w-[680px] text-[17px] leading-[1.8] text-[#1a1a1a] space-y-5 mb-10" data-id="element-12">
          <p data-id="element-13">
            If you've been struggling with recurring dental issues, morning
            sinus pressure, or frustrating bloating, you've probably been told
            they are separate problems.
          </p>

          <p data-id="element-14">
            But they aren't.{' '}
            <strong data-id="element-15">
              Recent discoveries show that a specific bacterial imbalance in the
              mouth acts as a gateway
            </strong>
            , silently affecting your sinuses and your entire digestive system
            at the same time.
          </p>

          <p data-id="element-16">
            Ordinary toothpastes and mouthwashes often make it worse by wiping
            out the good bacteria your body desperately needs to stay healthy
            from the inside out.
          </p>
        </div>

        {/* HIGHLIGHT BOX */}
        <div className="mx-auto max-w-[680px] mb-10 rounded-lg p-5 sm:p-6" style={{
        backgroundColor: '#e8f5e9',
        borderLeft: `4px solid ${GREEN}`
      }} data-id="element-17">
          <p className="text-[17px] sm:text-[18px] leading-[1.7] text-[#1a1a1a]" data-id="element-18">
            There is now a <strong data-id="element-19">simple, natural way</strong> to repopulate
            your mouth with the right nutrients to support{' '}
            <strong data-id="element-20">healthy teeth, clear sinuses, and smooth digestion</strong>{' '}
            all at once.
          </p>
        </div>

        {/* BULLET POINTS */}
        <ul className="mx-auto max-w-[560px] mb-10 space-y-3.5" data-id="element-21">
          {bullets.map((b, i) => <li key={i} className="flex items-start gap-3 text-[16px] text-[#1a1a1a]" data-id="element-22">
              <span className="flex-shrink-0 mt-0.5 w-6 h-6 rounded-full flex items-center justify-center" style={{
            backgroundColor: GREEN
          }} data-id="element-23">
                <Check size={14} className="text-white" strokeWidth={3} data-id="element-24" />
              </span>
              <span data-id="element-25">{b}</span>
            </li>)}
        </ul>

        {/* SOCIAL PROOF BAR */}
        <div className="mx-auto max-w-[560px] bg-[#f9f9f9] rounded-lg py-4 px-5 mb-10 text-center" data-id="element-26">
          <p className="text-[13px] sm:text-sm italic text-gray-600" data-id="element-27">
            ⭐⭐⭐⭐⭐ Join over{' '}
            <span className="font-semibold text-gray-800" data-id="element-28">127,000 people</span>{' '}
            who have already discovered this
          </p>
        </div>

        {/* CTA */}
        <div className="text-center mb-10" data-id="element-29">
          <p className="text-sm text-gray-500 mb-4" data-id="element-30">
            Ready to discover the root cause?
          </p>
          <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="inline-block w-full max-w-[420px] text-center font-bold text-[18px] text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 hover:brightness-110" style={{
          backgroundColor: GREEN,
          height: '60px',
          lineHeight: '60px'
        }} data-id="element-31">
            CONTINUE TO THE FULL REPORT →
          </a>
          <p className="text-xs text-gray-500 mt-3" data-id="element-32">
            Check availability and see how it works
          </p>
        </div>

        {/* TRUST BADGES */}
        <div className="mx-auto max-w-[560px] grid grid-cols-3 gap-4 mb-12" data-id="element-33">
          <div className="flex flex-col items-center text-center gap-2" data-id="element-34">
            <Lock size={22} className="text-[#777777]" strokeWidth={1.75} data-id="element-35" />
            <p className="text-[11px] sm:text-xs text-[#777777] leading-tight" data-id="element-36">
              100% Secure
            </p>
          </div>
          <div className="flex flex-col items-center text-center gap-2" data-id="element-37">
            <ShieldCheck size={22} className="text-[#777777]" strokeWidth={1.75} data-id="element-38" />
            <p className="text-[11px] sm:text-xs text-[#777777] leading-tight" data-id="element-39">
              Clinically Researched
            </p>
          </div>
          <div className="flex flex-col items-center text-center gap-2" data-id="element-40">
            <Leaf size={22} className="text-[#777777]" strokeWidth={1.75} data-id="element-41" />
            <p className="text-[11px] sm:text-xs text-[#777777] leading-tight" data-id="element-42">
              Natural Ingredients
            </p>
          </div>
        </div>

        {/* COMPLIANCE FOOTER */}
        <div className="mx-auto max-w-[640px] text-center space-y-4 pt-6 border-t border-gray-100" data-id="element-43">
          <p className="text-[11px] leading-relaxed text-gray-400" data-id="element-44">
            This site is not part of the Facebook website or Facebook Inc.
            Additionally, this site is NOT endorsed by Facebook in any way.
            FACEBOOK is a trademark of FACEBOOK, Inc.
          </p>
          <p className="text-[11px] leading-relaxed text-gray-400" data-id="element-45">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure or prevent any disease.
          </p>
        </div>
      </article>
    </div>;
}